(() => {
  if (customElements.get('rks-size-guide')) return;
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  class SizeGuide extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const controller = this.controller = new AbortController();
      try {
        const source = new URL(this.dataset.source, location.href);
        const response = await fetch(source, {signal: controller.signal});
        if (!response.ok) throw new Error('Size guide unavailable');
        const data = await response.json();
        if (!this.isConnected || controller !== this.controller) return;
        const assets = new URL('.', source).href;
        const frame = document.createElement('iframe');
        frame.title = '全機種対応 手帳型ケース 推奨サイズ表';
        frame.style.cssText = 'display:block;width:100%;height:600px;border:0;background:#fff;';
        this.onMessage = event => {
          if (event.source !== frame.contentWindow || event.origin !== location.origin || event.data?.channel !== 'rks-size-guide-v1') return;
          const {type, height, top} = event.data;
          if (type === 'height' && Number.isFinite(height)) frame.style.height = Math.max(100, Math.min(height, 60000)) + 'px';
          if (type === 'anchor' && Number.isFinite(top)) {
            window.scrollTo({top: window.scrollY + frame.getBoundingClientRect().top + top - 100, behavior: 'instant'});
          }
        };
        window.addEventListener('message', this.onMessage);
        frame.srcdoc = `<!doctype html><html lang="ja"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><link rel="stylesheet" href="${escape(assets+'rks-size-guide.css')}"></head><body data-parent-origin="${escape(location.origin)}">${data.body.replaceAll('__ASSETS__', assets)}<script src="${escape(assets+'rks-size-guide.js')}"></script><script src="${escape(assets+'rks-size-guide-bridge.js')}"></script></body></html>`;
        this.replaceChildren(frame);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.loaded = false;
        const message = document.createElement('p');
        message.setAttribute('role', 'alert');
        message.textContent = 'サイズ表を読み込めませんでした。ページを再読み込みしてください。';
        this.replaceChildren(message);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      window.removeEventListener('message', this.onMessage);
      this.loaded = false;
    }
  }
  customElements.define('rks-size-guide', SizeGuide);
})();
